import Color from '../color.es6'
import Ren from '../ren-shape.es6'
import Konva from 'konva'
import Element from './element.es6'

export default class MelPpi extends Element {
  setDefaultShapes () {
    const signalStop = new Konva.Group({
      name: 'signalStop',
      x: 0,
      y: 0,
      visible: true
    })

    const signalStopLine = new Ren.Line({
      points: [0, 15, 30, 15],
      stroke: 'red',
      strokeEnabled: true,
      strokeWidth: 4
    })

    signalStop.add(signalStopLine)

    const straight = new Konva.Group({
      name: 'straight',
      x: 0,
      y: 0,
      visible: true
    })

    const straightLine = new Ren.Line({
      points: [15, 60, 15, 30],
      stroke: 'red',
      strokeEnabled: true,
      strokeWidth: 4
    })

    straight.add(straightLine)

    const left = new Konva.Group({
      name: 'left',
      x: 0,
      y: 0,
      visible: true
    })

    const leftLine = new Ren.Line({
      points: [5, 65, 25, 85],
      stroke: 'red',
      strokeEnabled: true,
      strokeWidth: 4
    })

    left.add(leftLine)

    const right = new Konva.Group({
      name: 'right',
      x: 0,
      y: 0,
      visible: true
    })

    const rightLine = new Ren.Line({
      points: [25, 65, 5, 85],
      stroke: 'red',
      strokeEnabled: true,
      strokeWidth: 4
    })

    right.add(rightLine)

    this.shapes.push(
      // basic shape three rooms
      new Ren.Rect({
        name: 'ppi',
        x: 0,
        y: 0,
        width: 30,
        height: 90,
        strokeWidth: 0.5,
        fill: Color.offlineGray,
        opacity: 0.8
      }),

      new Ren.Line({
        points: [0, 30, 30, 30],
        strokeWidth: 2,
        opacity: 0.8
      }),
      new Ren.Line({
        points: [0, 60, 30, 60],
        strokeWidth: 2,
        opacity: 0.8
      }),

      new Ren.Circle({
        name: 'circle',
        x: 15,
        y: 15,
        radius: 15,
        fill: Color.offlineGray
      }),

      new Ren.Circle({
        name: 'circle',
        x: 15,
        y: 45,
        radius: 15,
        fill: Color.offlineGray
      }),

      new Ren.Circle({
        name: 'circle',
        x: 15,
        y: 75,
        radius: 15,
        fill: Color.offlineGray
      }),

      new Ren.Line({
        points: [15, 90, 15, 110],
        strokeWidth: 2,
        opacity: 0.8
      }),

      new Ren.Line({
        points: [0, 110, 30, 110],
        strokeWidth: 2,
        opacity: 0.8
      }),

      signalStop,
      straight,
      left,
      right
    )
  }

  applyStatusOnShapes (newVariables, deviceTypes) {
    const status = newVariables || this.status
    super.applyStatusOnShapes(status)

    for (const [signalName, value] of Object.entries(status)) {
      console.log("mel-ppi signal name", signalName, value)
      this.modifyShape(signalName, 'visible', value === 1)
    }
  }
}
